<template>
    <ais-instant-search :search-client="searchClient" :index-name="pagesIndex" :routing="routing">
        <ais-configure :hits-per-page.camel="12" />

        <div ref="search" class="mb-24">
            <div class="flex flex-col justify-between h-auto mb-4 sm:flex-row sm:h-12">
                <div class="w-full">
                    <ais-search-box v-slot="{ currentRefinement, isSearchStalled, refine }">
                        <div
                            class="flex items-center justify-between w-full mx-auto mt-4 px-8 py-4 text-white bg-yellow-500 rounded-full overflow-hidden"
                        >
                            <input
                                class="w-full pr-3 pt-1 pb-1 mt-px -mb-px mr-5 text-xs font-bold tracking-widest text-white placeholder-white uppercase bg-transparent outline-none border-r border-white border-opacity-50"
                                type="search"
                                :value="currentRefinement"
                                placeholder="Search here…"
                                @input="refine($event.currentTarget.value)"
                            />

                            <img
                                :hidden="!isSearchStalled"
                                class="h-6"
                                src="/themes/bourkeshire/images/spinner.svg"
                                alt=""
                            />

                            <span
                                class="flex items-center justify-center w-12 text-white bg-yellow-500"
                            >
                                <!-- prettier-ignore -->
                                <svg class="w-4 h-4 stroke-current" viewBox="0 0 20 20">
                                    <g fill="none" fill-rule="evenodd" stroke-width="1.5" transform="translate(2 2)">
                                        <path stroke-linecap="round" d="M16 16L11 11"/>
                                        <circle cx="6.5" cy="6.5" r="6.5"/>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </ais-search-box>
                </div>
            </div>
        </div>

        <div class="mb-12 sm:mb-32">
            <ais-stats v-slot="{ nbHits }">
                <ais-hits v-if="nbHits" v-slot="{ items }" class="grid gap-5 grid-square">
                    <Page v-for="item in items" :key="item.objectID" :page="item" />
                </ais-hits>

                <p v-else class="text-center">
                    No results.
                </p>
            </ais-stats>

            <ais-pagination
                v-slot="{
                    currentRefinement,
                    pages,
                    isFirstPage,
                    isLastPage,
                    refine,
                    createURL
                }"
                :padding="2"
                @page-change="scrollTop"
            >
                <div class="flex justify-center mt-16 small text-grey-300">
                    <a
                        v-if="!isFirstPage"
                        class="flex items-center justify-center w-12 h-12"
                        :href="createURL(currentRefinement - 1)"
                        @click.prevent="refine(currentRefinement - 1)"
                    >
                        <svg
                            width="8"
                            height="16"
                            class="w-2 h-4 stroke-current"
                            viewBox="0 0 6 10"
                        >
                            <path
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="round"
                                stroke-width="1.5"
                                d="M4.931 1.069L1.069 4.931m0 .138l3.862 3.862"
                            />
                        </svg>
                    </a>

                    <a
                        v-for="page in pages"
                        :key="page"
                        class="flex items-center justify-center w-12 h-12 mx-1 rounded-full hover:text-grey-500 hover:bg-grey-200"
                        :class="{ 'text-white bg-theme-colour': page === currentRefinement }"
                        :href="createURL(page)"
                        @click.prevent="refine(page)"
                    >
                        {{ page + 1 }}
                    </a>

                    <a
                        v-if="!isLastPage"
                        class="flex items-center justify-center w-12 h-12"
                        :href="createURL(currentRefinement + 1)"
                        @click.prevent="refine(currentRefinement + 1)"
                    >
                        <svg
                            width="8"
                            height="16"
                            class="w-2 h-4 stroke-current"
                            viewBox="0 0 6 10"
                        >
                            <path
                                fill="none"
                                fill-rule="evenodd"
                                stroke-linecap="round"
                                stroke-width="1.5"
                                d="M1.069 8.931l3.862-3.862m0-.138L1.069 1.069"
                            />
                        </svg>
                    </a>
                </div>
            </ais-pagination>
        </div>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import Page from '@/components/Page.vue';
import { routing } from '@/routing';

export default {
    components: {
        Page
    },

    props: {
        query: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            searchClient: algoliasearch(window.algolia.id, window.algolia.key),
            routing: routing(`pages_${this.$root.hub}`)
        };
    },

    computed: {
        pagesIndex() {
            return `pages_${this.$root.hub}`;
        }
    },

    methods: {
        scrollTop() {
            const el = this.$refs.search;
            el.scrollIntoView();
        }
    }
};
</script>

<style scoped>
.subitem-wrapper {
    &::before,
    &::after {
        margin: auto;
        content: '';
    }
}
</style>
